module.exports = __webpack_public_path__ + "img/NoBackgroundColour.f1cb751b.svg";